var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginPrincipal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 205.906,
    height: 193.563,
    viewBox: "0 0 205.906 193.563",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Elipse_179",
    x: 24.898,
    y: 0,
    width: 181.008,
    height: 193.563,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12721",
    "data-name": "Trazado 12721",
    d: "M109.112,0A90.748,90.748,0,0,0,37.671,34.677H0V131.37H27.765A90.877,90.877,0,1,0,109.112,0Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ilustraci\\xF3n_principal",
    "data-name": "Ilustraci\\xF3n principal",
    transform: "translate(-60 -288.728)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 60, 288.73)",
    filter: "url(#Elipse_179)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_179-2",
    "data-name": "Elipse 179",
    cx: 84.504,
    cy: 90.782,
    rx: 84.504,
    ry: 90.782,
    transform: "translate(30.9 3)",
    fill: "#ffdede"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19743",
    "data-name": "Grupo 19743",
    transform: "translate(60 292)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19742",
    "data-name": "Grupo 19742",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22339",
    "data-name": "Rect\\xE1ngulo 22339",
    width: 33.524,
    height: 40.257,
    transform: "translate(132.865 42.341)",
    fill: "#1f120c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12675",
    "data-name": "Trazado 12675",
    d: "M182.34,42.085a16.976,16.976,0,1,0,23.545-5.243,17.041,17.041,0,0,0-23.545,5.243",
    transform: "translate(-46.959 -8.95)",
    fill: "#1f120c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12676",
    "data-name": "Trazado 12676",
    d: "M184.235,43.8a15.379,15.379,0,1,0,21.33-4.75,15.437,15.437,0,0,0-21.33,4.75",
    transform: "translate(-47.522 -9.595)",
    fill: "#fdbfb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12677",
    "data-name": "Trazado 12677",
    d: "M205.868,82.242l-.083,14.639c-.023,3.112-1.953,2.711-5.018,2.664-2.616-.04-5.053-.511-5.337-3.11l.8-18.581Z",
    transform: "translate(-51.097 -20.391)",
    fill: "#af5e4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12678",
    "data-name": "Trazado 12678",
    d: "M195.683,89.406l10.5-5.824-10.024-2.368Z",
    transform: "translate(-51.163 -21.271)",
    fill: "#4a280d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12679",
    "data-name": "Trazado 12679",
    d: "M182.725,52.336c0,8.437,6.57,15.277,14.674,15.277s14.674-6.84,14.674-15.277S205.5,38.159,197.4,38.159s-14.674,5.74-14.674,14.177",
    transform: "translate(-47.776 -9.994)",
    fill: "#1f120c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12680",
    "data-name": "Trazado 12680",
    d: "M179.3,66.263a4.01,4.01,0,1,0,4.01-4.008,4.009,4.009,0,0,0-4.01,4.008",
    transform: "translate(-46.879 -16.306)",
    fill: "#af5e4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12681",
    "data-name": "Trazado 12681",
    d: "M223.679,66.263a4.011,4.011,0,1,1-4.01-4.008,4.009,4.009,0,0,1,4.01,4.008",
    transform: "translate(-56.386 -16.306)",
    fill: "#af5e4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12682",
    "data-name": "Trazado 12682",
    d: "M186.173,53.266a54.668,54.668,0,0,0,1.463,12.477c.716,3.022,2.73,5.133,5.576,6.834l.518.309a10.023,10.023,0,0,0,9.958.108c3.084-1.749,5.243-4.054,5.908-7.3a79.9,79.9,0,0,0,1.34-12.432s1.15-12.723-12.205-12.476-12.559,12.476-12.559,12.476",
    transform: "translate(-48.675 -10.683)",
    fill: "#af5e4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12683",
    "data-name": "Trazado 12683",
    d: "M191.66,42.012s3.2,14.216,21.954,12.932c0,0-.74-14.029-9.831-15.2,0,0-8.895-1.278-12.123,2.269",
    transform: "translate(-50.112 -10.351)",
    fill: "#1f120c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12684",
    "data-name": "Trazado 12684",
    d: "M194.526,40.785s-.643,9.822-8.659,15.436l-1.155-4.668s-1.275-9.774,9.814-10.768",
    transform: "translate(-48.283 -10.682)",
    fill: "#1f120c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12685",
    "data-name": "Trazado 12685",
    d: "M216.207,57.362l2.175,6.089.944-6.089Z",
    transform: "translate(-56.53 -15.024)",
    fill: "#1f120c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12686",
    "data-name": "Trazado 12686",
    d: "M188.661,57.362l-2.254,5.578-.865-5.578Z",
    transform: "translate(-48.512 -15.024)",
    fill: "#1f120c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12687",
    "data-name": "Trazado 12687",
    d: "M191.99,152.931s17.813,20.1,17.444,41.394-4.054,110.114-4.054,110.114h-16.2l-5.892-119.806-2.138-.131L152.661,304.491l-15.115-1.6,18.063-115.4s5.444-20.5,15.441-32.846Z",
    transform: "translate(-35.963 -40.055)",
    fill: "#228f99"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_96",
    "data-name": "L\\xEDnea 96",
    y1: 1.704,
    x2: 9.787,
    transform: "translate(142.547 143.492)",
    fill: "none",
    stroke: "#09090b",
    strokeWidth: 0.77
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12688",
    "data-name": "Trazado 12688",
    d: "M228.407,113.147l9.509,35.914a4.82,4.82,0,0,1-3.863,6.124,5.656,5.656,0,0,1-5.808-3.115L216,117.429a6.568,6.568,0,1,1,12.405-4.282",
    transform: "translate(-56.354 -28.402)",
    fill: "#af5e4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12689",
    "data-name": "Trazado 12689",
    d: "M242.63,163.485l4.064,36.884-7.212-.329-6.9-35.261c-.494-2.817,1.439-6.222,4.271-6.631,2.892-.417,5.538,2.427,5.779,5.337",
    transform: "translate(-60.79 -41.41)",
    fill: "#af5e4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12690",
    "data-name": "Trazado 12690",
    d: "M247.655,211.858s10.065,12.687-.162,19.424a1.711,1.711,0,0,1-2.156-.238l-.076-.078a1.736,1.736,0,0,1-.082-2.338c1.393-1.665,3.171-5.038-.453-9.027,0,0-1.678.562-1.1,3.975a1.4,1.4,0,0,1-1.4,1.651,1.443,1.443,0,0,1-1.325-.988c-.753-2.225-2.158-7.773,1.176-11.041Z",
    transform: "translate(-62.739 -55.489)",
    fill: "#af5e4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12691",
    "data-name": "Trazado 12691",
    d: "M166.4,105.141l-49.345,45.682-5.783-7.017,45.892-45.384c2-2.492,6.687-3.313,9.118-1.244l-.292-.266a5.654,5.654,0,0,1,.41,8.229",
    transform: "translate(-29.093 -25.145)",
    fill: "#af5e4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12692",
    "data-name": "Trazado 12692",
    d: "M200.268,97.29l13.458,9.227-10.86,31.424-20.94,1.717-2.787-28.828L180.23,95.7Z",
    transform: "translate(-46.838 -25.065)",
    fill: "#af5e4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12693",
    "data-name": "Trazado 12693",
    d: "M203.75,101s-2.689,8.34-10.644,6.532-8.258-11.545-8.258-11.545l-10.328-.793-4.673,60.99,10.945.121,32.016-.121V105.116Z",
    transform: "translate(-44.409 -24.932)",
    fill: "#b7066d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12694",
    "data-name": "Trazado 12694",
    d: "M221.233,130.435,216.06,117.43c-1.539-3.442.43-7.333,4.35-8.6,4-1.289,8.4.685,9.608,4.313l4.2,14.1Z",
    transform: "translate(-56.354 -28.402)",
    fill: "#b7066d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12695",
    "data-name": "Trazado 12695",
    d: "M157.74,107.453l9.774-10c2.517-2.8,6.868-2.615,9.611.41,2.8,3.09,2.784,7.873-.038,10.448l-11.164,9.569Z",
    transform: "translate(-41.243 -25.005)",
    fill: "#b7066d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12696",
    "data-name": "Trazado 12696",
    d: "M197.821,124.168c5.815.21,10.744-9.324,11.227-22.647l-1.557-.706c-.436,12.061-4.811,22.017-9.615,21.844s-8.8-14.528-8.373-26.443l-1.818-.139c-.477,13.171,4.318,27.882,10.136,28.092",
    transform: "translate(-49.064 -25.164)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22340",
    "data-name": "Rect\\xE1ngulo 22340",
    width: 13.585,
    height: 11.498,
    transform: "translate(142.52 112.373) rotate(-87.928)",
    fill: "#f1f1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12697",
    "data-name": "Trazado 12697",
    d: "M203.055,142.362a3.05,3.05,0,1,1-2.937-3.155,3.049,3.049,0,0,1,2.937,3.155",
    transform: "translate(-51.497 -36.46)",
    fill: "#cccbcb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22341",
    "data-name": "Rect\\xE1ngulo 22341",
    width: 3.102,
    height: 3.102,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 134.236, 88.494)",
    fill: "#f1f1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12698",
    "data-name": "Trazado 12698",
    d: "M75.653,155.6h-18.8a4.662,4.662,0,0,1-4.663-4.66V113.292A12.279,12.279,0,0,1,64.47,101.018H75.653a4.662,4.662,0,0,1,4.663,4.661v45.262a4.662,4.662,0,0,1-4.663,4.66",
    transform: "translate(-13.645 -26.458)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12699",
    "data-name": "Trazado 12699",
    d: "M132.483,181.091,146,154.632l-15.918-23.7,15.116-7.855,11.919,20.286c4.179,7.18,5.7,12.228,1.56,17.042l-20.44,25.692Z",
    transform: "translate(-34.011 -32.235)",
    fill: "#f7a59c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12700",
    "data-name": "Trazado 12700",
    d: "M134.435,200.1s-3.111-.345-3.609,7.089-2.365,12.325,2.736,12.676,13.814-3.916,7.871-9.907l-2.209-6.3Z",
    transform: "translate(-34.011 -52.408)",
    fill: "#f7a59c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12701",
    "data-name": "Trazado 12701",
    d: "M126.378,97.416s13.49,1.294,21.362,22.238l-21.832,16.233-3.749-12.835Z",
    transform: "translate(-31.94 -25.515)",
    fill: "#b7006d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12702",
    "data-name": "Trazado 12702",
    d: "M62.66,192.271,54.1,320.451l25.384.208L88.4,212.1l9.682,106.292,27.654-2.771L112.552,192.271Z",
    transform: "translate(-14.146 -50.359)",
    fill: "#7a4aa8"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_97",
    "data-name": "L\\xEDnea 97",
    y1: 3.224,
    x2: 8.981,
    transform: "translate(74.254 158.519)",
    fill: "none",
    stroke: "#09090b",
    strokeWidth: 0.775
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12703",
    "data-name": "Trazado 12703",
    d: "M42.62,118.356,36.6,126.078l-8.278-27.79-8.845.993,4.2,35.258a10.088,10.088,0,0,0,16.543,7.779L56.5,128.007Z",
    transform: "translate(-5.091 -25.743)",
    fill: "#ffb1a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12704",
    "data-name": "Trazado 12704",
    d: "M7.239,76.155a.983.983,0,0,1,1.464-.1l5,5.721-2.13-9.787a1.042,1.042,0,0,1,2-.569l3.114,8.8L15.054,69.289a.936.936,0,0,1,1.831-.377l2.63,9.955-.6-8.68a1.116,1.116,0,0,1,1.19-1.122c.666-.038,1.084.656,1.161,1.173l1.525,12.174,1.568-3.789a1.371,1.371,0,0,1,2.7.252c.414,8.841-2.393,12.153-2.393,12.153L17.023,93.1a15.823,15.823,0,0,1-5.36-8.666L7.228,77.342a.982.982,0,0,1,.011-1.187",
    transform: "translate(-1.839 -17.867)",
    fill: "#ffb1a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12705",
    "data-name": "Trazado 12705",
    d: "M68.06,96.3a16.6,16.6,0,0,0-9.756,6.217c-4.211,5.411-9.831,15.46-9.831,15.46l14.478,14.883,6.622-5.5Z",
    transform: "translate(-12.674 -25.221)",
    fill: "#b7006d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12706",
    "data-name": "Trazado 12706",
    d: "M72.231,96.3l-1.282,8.586s-3.182,9.526-2.565,11.958l-3.959,50.266,53.164,6.122-3.477-68.649a15.262,15.262,0,0,0,.089-4.427,3.493,3.493,0,0,0-3.284-3.068l-10.665-.534Z",
    transform: "translate(-16.845 -25.221)",
    fill: "#b7006d"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_98",
    "data-name": "L\\xEDnea 98",
    x2: 0.702,
    y2: 15.645,
    transform: "translate(97.884 90.839)",
    fill: "none",
    stroke: "#09090b",
    strokeWidth: 0.775
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_99",
    "data-name": "L\\xEDnea 99",
    y1: 16.015,
    x2: 1.261,
    transform: "translate(50.278 91.619)",
    fill: "none",
    stroke: "#09090b",
    strokeWidth: 0.775
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12707",
    "data-name": "Trazado 12707",
    d: "M108.909,90.766l-.588-14.48-11.407-.323-.695,16.981c-.076,1.858,1.538,1.522,3.4,1.427l6.292-.319a3.163,3.163,0,0,0,3-3.286",
    transform: "translate(-25.157 -19.896)",
    fill: "#ffb1a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12708",
    "data-name": "Trazado 12708",
    d: "M97.715,79.418l11.392,6.694-.394-9.712Z",
    transform: "translate(-25.549 -20.01)",
    fill: "#4a280d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12709",
    "data-name": "Trazado 12709",
    d: "M124.16,60.916c0,2.358-1.051,4.269-2.346,4.269s-2.346-1.911-2.346-4.269,1.05-4.269,2.346-4.269,2.346,1.911,2.346,4.269",
    transform: "translate(-31.236 -14.837)",
    fill: "#ffb1a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12710",
    "data-name": "Trazado 12710",
    d: "M83.963,60.916c0,2.358,1.182,4.269,2.64,4.269s2.64-1.911,2.64-4.269-1.182-4.269-2.64-4.269-2.64,1.911-2.64,4.269",
    transform: "translate(-21.953 -14.837)",
    fill: "#ffb1a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12711",
    "data-name": "Trazado 12711",
    d: "M113.846,47.313a59.268,59.268,0,0,1-1.572,13.47c-.77,3.263-2.934,5.543-5.993,7.379l-.552.331a10.658,10.658,0,0,1-10.71.12c-3.315-1.887-5.635-4.376-6.348-7.877a86.592,86.592,0,0,1-1.441-13.422s-1.236-13.737,13.118-13.47,13.5,13.47,13.5,13.47",
    transform: "translate(-22.8 -8.863)",
    fill: "#ffb1a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12712",
    "data-name": "Trazado 12712",
    d: "M87.148,53.952s3.029-9.757.836-16.07c0,0-8.461,2.43-.836,16.07",
    transform: "translate(-21.953 -9.922)",
    fill: "#4a280d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12713",
    "data-name": "Trazado 12713",
    d: "M121.728,53.952s-3.822-9.757-1.628-16.07c0,0,7.9,1.947,1.628,16.07",
    transform: "translate(-31.224 -9.922)",
    fill: "#4a280d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12714",
    "data-name": "Trazado 12714",
    d: "M90.011,40.442s2.425-4.367,6.777-1.949,8.649,4.712,16.423,2.813l-1.033-5.263s-10.791-11.479-22.845,0Z",
    transform: "translate(-23.357 -8.104)",
    fill: "#4a280d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12715",
    "data-name": "Trazado 12715",
    d: "M93.941,96.3l-6.741.082s-.723,6.826,12.437,7.162,13.379-6.724,13.379-6.724L105.9,96.3Z",
    transform: "translate(-22.798 -25.221)",
    fill: "#ffb1a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12716",
    "data-name": "Trazado 12716",
    d: "M115.19,50.79c0,2.1-7.31,3.808-16.328,3.808s-16.328-1.7-16.328-3.808,7.31-3.808,16.328-3.808,16.328,1.7,16.328,3.808",
    transform: "translate(-21.579 -12.305)",
    fill: "#98045b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12717",
    "data-name": "Trazado 12717",
    d: "M98.861,28.022c-9.018,0-16.328,7.9-16.328,17.653h32.656c0-9.749-7.31-17.653-16.328-17.653",
    transform: "translate(-21.579 -7.339)",
    fill: "#b7006d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12718",
    "data-name": "Trazado 12718",
    d: "M100.147,120.94c6.006.217,11.1-10.6,11.6-24.357l-1.554-.032c-.451,12.454-5.028,23.01-9.989,22.83s-8.777-10.724-8.331-23.029L90.313,96.3c-.493,13.6,3.826,24.428,9.834,24.645",
    transform: "translate(-23.603 -25.221)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22342",
    "data-name": "Rect\\xE1ngulo 22342",
    width: 14.029,
    height: 11.874,
    transform: "translate(70.102 109.523) rotate(-87.929)",
    fill: "#f1f1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12719",
    "data-name": "Trazado 12719",
    d: "M105.329,138.178a3.149,3.149,0,1,1-3.033-3.258,3.149,3.149,0,0,1,3.033,3.258",
    transform: "translate(-25.893 -35.337)",
    fill: "#cccbcb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22343",
    "data-name": "Rect\\xE1ngulo 22343",
    width: 3.203,
    height: 3.203,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 88.726, 91.618)",
    fill: "#f1f1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12720",
    "data-name": "Trazado 12720",
    d: "M79.307,96.376s5.029,31.594-13.153,54.534l.437-5.55s12.715-19.547,9.942-48.984Z",
    transform: "translate(-17.297 -25.242)",
    fill: "#333"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPrincipal);
export default __webpack_public_path__ + "static/media/login_principal.fab93046f3b7abd56dc1214c600595a4.svg";
export { ForwardRef as ReactComponent };